import { Component, OnInit, Input, OnDestroy, Inject } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';

import {
  IApproveDocsRequest,
  IRejectDocsRequest,
  RejectReason
} from '../../../features/employee-detail/models/approve-document.model';
import { fromApproveActions } from '../../../../app/features/employee-detail/actions';
import { IRejectionReason } from '../../../../../src/app/static-data/models/rejection-reason.model';
import { saveUploadedFileToStore, loadGetUploadedDocs } from '../../../../app/features/employee-detail/actions/get-uploaded-doc.actions';
import { fromOpenFileSelector } from '../../../features/employee-detail/selectors';
import { IUploadDocsParams } from '../../../features/employee-detail/models/IUploadDocsParams.model';
import { fromSelectedBusinessSelector } from '../../../features/businesses/selectors';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import { fromStaticDataRejectionReasonSelector } from '../../../static-data/selectors';
import { IGovIdProof } from '../../../../../src/app/features/employee-detail/models/govId.model';
import {
  getPreviousProofOfGovIds,
} from '../../../features/employee-detail/selectors';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { APP_CONFIG } from '../../../../../src/app/config/app-config.module';
import { AppConfig } from '../../../../../src/app/core/config-models/app-config.model';
import { fromHomeAddressActions, fromGovIdProofActions } from '../../../features/employee-detail/actions';
import {
  hasNonBlankEmployeeRejectionMessage,
  hasRejectionReasonSelection
} from 'src/app/shared/utils/document-rejection-form.util';

@Component({
  selector: 'app-manage-documents',
  templateUrl: './manage-documents.component.html',
  styleUrls: ['./manage-documents.component.css']
})
export class ManageDocumentsComponent implements OnInit, OnDestroy {

  @Input() currentFilesData$: Observable<any[]>;
  @Input() previousFilesData$: Observable<any[]>;
  @Input() businessEntityId$: string = '';

  loadPreviousProofOfGovIdData$: Observable<IGovIdProof[]>;

  videoFile: any;
  video: boolean;

  imageClicked: boolean;
  getCurrentPicObs$: Observable<any>;
  openPic: boolean;
  extraInfo: string;

  getUploadedFileStatus$: Observable<boolean>;
  displayRejectModal: boolean;
  fileID: string;
  fileType: string;
  fileTypeId: string;
  reason: string;
  privateNotes: string;
  option: IRejectionReason;
  rejectionReason$: Observable<IRejectionReason[]>;
  subscription: Subscription = new Subscription();
  chosen: string;
  businessId: string;
  displayUploadModal: boolean;
  fileNameFICA: string;
  uploadFICAURL: string;
  tabsWithText:any[];
  selectedTabIndex:number = 0;
  headers: any;
  allRejectionReasons: any[];
  selectedRejectReason: any;
  rejectionSubmitAttempted = false;

  constructor(
    private store: Store,
    private helperService: HelpersService,
    private analytics: AngularFireAnalytics,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.rejectionReason$ = this.store.select(fromStaticDataRejectionReasonSelector.getStaticDataRejectionResponse);
    this.rejectionReason$.subscribe(response=>{
      this.allRejectionReasons = response;
    });
    this.tabsWithText = [
      {id:1, text:'Current'},
      {id:2, text:'Previous'}
    ];

    var bearerToken = sessionStorage.getItem('token');
    this.headers = { 'Authorization': `Bearer ${bearerToken}` };
  }

  ngOnInit() {
    this.displayRejectModal = false;
    this.displayUploadModal = false;

    this.subscription.add(
      this.store.select(fromSelectedBusinessSelector.getSelectedBusinesses).subscribe(data => {
        if (data != undefined) {
          this.businessId = data.id;
        }
      })
    );
    this.loadPreviousProofOfGovIdData$ = this.store.select(getPreviousProofOfGovIds);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSelectionChanged(e){
    var index = e.addedItems[0].id - 1;
    this.selectedTabIndex = index;
  }

  openFileInBrowser(val) {

    this.analytics.logEvent('view document in browser');
    let opened: boolean;
    opened = true;

    var extension: string;
    var trimmedExtension: string;
    extension = val.fileName.replace(/^[^.]+-+. */, '');
    trimmedExtension = extension.substring(extension.indexOf('.') + 1).trim();

    let req: IUploadDocsParams = {
      businessId: 'undefined',
      uploadedFileId: val.uploadedFileId
    };

    this.store.dispatch(loadGetUploadedDocs({ request: req }));

    this.getUploadedFileStatus$ = this.store.pipe(select(fromOpenFileSelector.getOpenFileSuccess));

    this.getCurrentPicObs$ = this.store.pipe(select(fromOpenFileSelector.getUploadedFile));

    this.getUploadedFileStatus$.pipe(
      map(status => {
        return of(true);
      })
    );

    this.getCurrentPicObs$.pipe(
      map(base64 => {
        return of(base64);
      })
    );

    const newObs$ = new Observable<any>(response => {
      this.getUploadedFileStatus$.subscribe(status => {
        if (status) {
          response.next(this.getCurrentPicObs$);
          this.openPic = true;
        }
      });
    });

    newObs$.subscribe(y => {
      if (y !== undefined) {
        y.subscribe(base64 => {
          if (base64 !== undefined) {
            this.store.dispatch(saveUploadedFileToStore({ savedBase64: undefined }));
            if (opened) {
              this.openFileInBrowser2(trimmedExtension, base64);
              opened = false;
              this.openPic = false;
            }
          }
        }).remove();
      }
    });
  }

  openFileInBrowser2(extension, newBase64Str) {
    var win;

    switch (true) {
      case extension === 'jpeg' ||
        extension === 'JPG' ||
        extension === 'png' ||
        extension === 'PNG' ||
        extension === 'txt' ||
        extension === 'JPEG' ||
        extension === 'jpg' ||
        extension === 'TXT' ||
        extension === 'tiff' ||
        extension === 'TIFF':
        win = window.open();

        let data = `data:image/${extension};base64,${newBase64Str}`;

        win.document.write(
          '<iframe src="' +
            data +
            '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
        );
        break;
      case extension === 'rtf':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/rtf;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'xml':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/xml;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'pdf' || extension === 'PDF':
        win = window.open();
        win.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(newBase64Str) + "'></iframe>"
        );
        break;
      case extension === 'mp4' ||
        extension === 'm4v' ||
        extension === '3gp' ||
        extension === 'avi' ||
        extension === 'flv' ||
        extension === 'mkv' ||
        extension === 'mov' ||
        extension === 'mpeg' ||
        extension === 'mpg' ||
        extension === 'mts' ||
        extension === 'vob' ||
        extension === 'webm' ||
        extension === 'wmv':
        this.videoFile = `data:${extension};base64,${newBase64Str}`;
        this.video = true;
        break;
      default:
        break;
    }
  }

  get showRejectionReasonError(): boolean {
    return (
      this.rejectionSubmitAttempted &&
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option)
    );
  }

  get showEmployeeMessageError(): boolean {
    return this.rejectionSubmitAttempted && !hasNonBlankEmployeeRejectionMessage(this.reason);
  }

  saveRejectionReason() {
    this.rejectionSubmitAttempted = true;
    if (
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option) ||
      !hasNonBlankEmployeeRejectionMessage(this.reason)
    ) {
      return;
    }
    this.rejectionSubmitAttempted = false;

    const rejectReason: RejectReason = {
      customerId: this.helperService.checkCustomerIdState(),
      adminPrivateNotes: this.privateNotes,
      extraInfo: this.reason,
      uploadedFileId: this.fileID,
      uploadedFileRejectReasonId: this.selectedRejectReason.id
    };

    const req: IRejectDocsRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      uploadedFileId: this.fileID,
      uploadedFileType: this.fileTypeId,
      rejectReason: rejectReason
    };

    this.store.dispatch(
      fromApproveActions.rejectDocumentRequest({
        request: req
      })
    );
    this.displayRejectModal = false;
    this.selectedRejectReason = null;
  }

  /* #region  decline doc */
  declineDocument(uploadedFileId, uploadedFileTypeDescription, uploadedFileTypeId) {
    this.displayRejectModal = true;
    this.fileID = uploadedFileId;
    this.fileType = uploadedFileTypeDescription;
    this.fileTypeId = uploadedFileTypeId;

    this.privateNotes = '';
    this.reason = '';
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
    this.option = {
      id: '',
      description: '',
      extraInfo: ''
    };
  }
  /* #endregion */

  close() {
    this.imageClicked = false;
    this.video = false;
  }

  imageApproveFunction(uploadedFileId, userIdentityId, uploadedFileTypeDescription, uploadedFileTypeId) {
    const req: IApproveDocsRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      userIdentityId: userIdentityId,
      uploadedFileId: uploadedFileId,
      uploadedFileType: uploadedFileTypeId
    };

    this.store.dispatch(
      fromApproveActions.approveDocumentRequest({
        request: req
      })
    );
  }


  onChangeTab($event) {}

  selected(e) {
    this.selectedRejectReason = this.allRejectionReasons.find(item => item.id === e.value);
    this.reason = this.selectedRejectReason?.extraInfo ?? '';
  }

  uploadDoc() {
    this.displayUploadModal = true;
  }


  replaceFICADocument(file) {
    this.fileNameFICA = '';
    this.uploadFICAURL = '';
    if (file.uploadedFileTypeDescription === 'Identity') {
      let uploadedFileIdentityId = file.uploadedFileId;
      this.fileNameFICA = `Identity/${uploadedFileIdentityId}`;
      this.uploadFICAURL = `${this.appConfig.apiEndpoint}/CustomerAdmin/${this.helperService.checkCustomerIdState()}/Identity/UploadedFile/${uploadedFileIdentityId}/Replace`;
    } else if (file.uploadedFileTypeDescription === 'Address') {
      let uploadedFileAddressId = file.uploadedFileId;
      this.fileNameFICA = `Address/${uploadedFileAddressId}`;
      this.uploadFICAURL = `${this.appConfig.apiEndpoint}/CustomerAdmin/${this.helperService.checkCustomerIdState()}/HomeAddress/UploadedFile/${uploadedFileAddressId}/Replace`;
    }
  }

  ficaDocUploadControl(val, fileUploader) {
    this.helperService.notifySuccess('Uploaded succesfully', 300, 3000);

    this.store.dispatch(
      fromHomeAddressActions.loadHomeAddresss({
        request: this.helperService.checkCustomerIdState()
      })
    );

    this.store.dispatch(
      fromGovIdProofActions.loadProofGovIds({
        request: this.helperService.checkCustomerIdState()
      })
    );

    fileUploader.clear();
  }

  errorUploadedFICA(fileUploader, error) {
    this.helperService.handleGeneralErrors(false, 'Oops', `${error.error.status} - ${error.error.statusText}`);
    fileUploader.clear();
  }

  closeRejectionPop(){
    this.displayRejectModal = false;
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
  }
}
